import React from 'react';
import { Link } from 'react-router-dom';
import tlanimi_logo from '../img/tlanimi_brown_360.png';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="App-footer">
      <p className="float-end"><a href="#">Back to top</a></p>
      <p><img src={tlanimi_logo} className="Footer-logo" alt="tlanimi logo"/> &copy; {currentYear} Tlanimi. All rights reserved. &middot; <Link to="/privacy">Privacy</Link>.</p>
    </footer>
  );
}

export default Footer;
